import { render, staticRenderFns } from "./xs.vue?vue&type=template&id=e800fcc0&scoped=true"
var script = {}
import style0 from "./xs.vue?vue&type=style&index=0&id=e800fcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e800fcc0",
  null
  
)

export default component.exports